const GA_ID = process.env.REACT_APP_GA4_ID;
const KEY = "ss_analytics_consent";

export const analyticsConfigured = Boolean(GA_ID);
export const getConsent = () => { try { return localStorage.getItem(KEY); } catch { return null; } };

export const loadAnalytics = () => {
  if (!GA_ID || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
};

export const setConsent = (value) => {
  try { localStorage.setItem(KEY, value); } catch { /* ignore */ }
  if (value === "granted") loadAnalytics();
};

export const track = (event, params = {}) => {
  if (typeof window.gtag === "function") window.gtag("event", event, params);
};
